<template>
  <div>
    <div class="page_title">活动列表</div>
    <div style="padding:20px;">
      <div class="container">
        <div class="flex between">
          <div class="searchbox">
            <div>活动名称</div>
            <el-input
              v-model="keywords"
              style="width:180px;margin:0 10px"
              @input="search"
              clearable
            />
            <el-button
              @click="search"
              type="info"
              style="background-color:#eceff2;;color:#747981;"
              >查询</el-button
            >
          </div>
          <el-button
            type="primary"
            @click="addActivity"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('366') : false
            "
            >新增活动</el-button
          >
        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%;min-width:1000px;"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column prop="act_name" label="活动名称" />

            <el-table-column prop="create_time" label="创建时间" />
            <el-table-column label="活动类型">
              <template slot-scope="scope">
                <div v-if="scope.row.act_user_type == 1">普通活动</div>
                <div v-if="scope.row.act_user_type == 2">会员活动</div>
              </template>
            </el-table-column>
            <el-table-column label="活动时间">
              <template slot-scope="scope">
                <div>{{ scope.row.start_time }} ~ {{ scope.row.end_time }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="route_url" label="路由链接" />
            <el-table-column prop="activity_price" label="活动销售金额" />
            <el-table-column prop="buy_count" label="付款人数" />
            <el-table-column prop="orderNum" label="活动订单数" />
            <el-table-column prop="phone" label="活动状态">
              <template slot-scope="scope">
                <div v-if="scope.row.now_time < scope.row.start_time">
                  未开始
                </div>
                <div
                  v-if="
                    scope.row.now_time > scope.row.start_time &&
                      scope.row.now_time < scope.row.end_time
                  "
                >
                  进行中
                </div>
                <div v-if="scope.row.now_time > scope.row.end_time">已结束</div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="edit(scope.row.act_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('367')
                      : false
                  "
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  v-if="scope.row.act_status == 1"
                  @click="updateDtatus(scope.row.act_id, 0)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('368')
                      : false
                  "
                  >关闭</el-button
                >
                <el-button
                  type="text"
                  v-else
                  @click="updateDtatus(scope.row.act_id, 1)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('368')
                      : false
                  "
                  >启用</el-button
                >
                <el-button
                  type="text"
                  @click="checkDtatus(scope.row.act_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1298')
                      : false
                  "
                  >查看</el-button
                >
                <el-button
                  type="text"
                  @click="checkScreen(scope.row.act_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1300')
                      : false
                  "
                  >活动大屏</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      keywords: "",
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        keywords: this.keywords,
        page: this.currentPage,
        pageNumber: this.pagesize,
      };

      this.axios.post("platform/shop/getShopActivityList", data).then((res) => {
        let list = res.data.list.map((item) => {
          item.create_time = dayjs
            .unix(item.create_time)
            .format("YYYY-MM-DD HH:mm");
          item.start_time = dayjs
            .unix(item.start_time)
            .format("YYYY-MM-DD HH:mm");
          item.end_time = dayjs.unix(item.end_time).format("YYYY-MM-DD HH:mm");
          item.now_time = dayjs(Date.now()).format("YYYY-MM-DD HH:mm");
          return item;
        });

        this.totalNum = res.data.total;
        this.tableData = list;
      });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },

    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //新增活动
    addActivity() {
      this.$router.push("addactivity");
    },
    //编辑活动
    edit(act_id) {
      this.$router.push({
        path: "addactivity",
        query: {
          act_id,
        },
      });
    },
    //更改状态
    updateDtatus(act_id, act_status) {
      this.$confirm("确定要更改活动状态吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.axios
            .post("platform/shop/editShopActivityStatus", {
              act_id,
              act_status,
            })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("操作成功");
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    checkDtatus(act_id) {
      this.$router.push({
        path: "ActivityDetail",
        query: {
          act_id,
        },
      });
    },
    checkScreen(act_id) {
      const { href } = this.$router.resolve({
        path: "/activityScreen",
        query: { act_id: act_id },
      });
      window.open(href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
</style>
